<template>
	<div class="bg-white all margin-left padding-lr">
		<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" :rules="rules"
			ref="formLabelAlign">
			<el-form-item label="标题" prop="title">
				<input class="titmep height54 padding-lr-sm bge" v-model="formLabelAlign.title"
					placeholder="请用一段话，描述您的岗位标题..."></input>
			</el-form-item>
			<el-form-item label="描述" prop="desc">
				<textarea class="txtmep padding-sm bge" v-model="formLabelAlign.desc" placeholder="请描述详情"></textarea>
			</el-form-item>
			<!-- <div class="fillbtn">
				<el-upload
				  class="upload-demo"
				  action="https://manage.ciiply.com/api/pc/user/upFile"
				  :on-change="handleChange"
				  :file-list="fileList"
				  :limit="1">
				  <el-button class="tnb" plain @click="uploadFile()">导入文件</el-button>
				</el-upload>
			</div> -->
			<el-form-item label="全部类别" prop="category">
				<!-- <el-cascader :options="options" v-model="formLabelAlign.category" :props="props" clearable>
				</el-cascader> -->
				<el-select v-model="formLabelAlign.category" placeholder="请选择类别">
				     <el-option :label="item.name" v-for="(item,index) in profession" :key="index" :value="item.id"></el-option>
				   </el-select>
			</el-form-item>
			<el-form-item label="信息类别" prop="settlement">
				<el-select v-model="formLabelAlign.settlement" placeholder="请选择">
					<el-option v-for="(item,index) in array" :key="index" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item label="地址" prop="address">
				<!-- <el-cascader :options="addressname" :disabled="addressdisabled" v-model="address" :props="addressprops" clearable> </el-cascader> -->
				<div class="cascadera padding-lr-sm">
					<div class="casca text-right" @click.stop="chosecit">{{ addressinfo.join(',')}}</div>
					<div class="flex bg-white align-center cate pointer" v-if="ishowcity">
						<ul class="blobk300">
							<li class="pointer text-left flex align-center justify-between"
								v-for="(item,index) in provinceList" :key="index" @click="chooseProvince(item,index)">
								<div :class="item.ischeck?'text-theme':''">{{item.name}}</div>
								<i class="el-icon-arrow-right text-lg"></i>
							</li>
						</ul>
						<ul class="blobk300">
							<li class="pointer text-left flex align-center justify-between"
								v-for="(item,index) in cityList" :key="index" @click="chooseCity(item,index)">
								<div :class="item.ischeck?'text-theme':''">{{item.name}}</div>
							</li>
						</ul>
					</div>
				</div>
			</el-form-item>
			
			<!-- <el-form-item label="地址" prop="area">
				<input class="titmep height54 padding-lr-sm bge" v-model="formLabelAlign.area"
					placeholder="请输入地址"></input>
			</el-form-item> -->
			<el-form-item label="预算金额" prop="money">
				<!-- <input class="titmep padding-lr-sm text-right height54" type="number" v-model="formLabelAlign.money"
					placeholder="可面议"></input> -->
				<div class="padding-lr-sm">
					<el-input type="number" v-model.number="formLabelAlign.money" autocomplete="off" placeholder="可面议">
					</el-input>
				</div>
			</el-form-item>

			<div @click="dialogVisible = true">
				<el-radio v-model="radio" label="1">发布招标采购信息即表示遵守 <span class="text-theme">《蓝友网信息发布规则》</span>，如果您违反规则可能导致您的账号异常 </el-radio>
			</div>
			<el-button class="creat" type="primary" @click="submitForm()">保存提交</el-button>
			<p class="text-xs text-999">发布成功后，平台会在1个工作日内审核完成即可显示</p>
		</el-form>
		
		<el-dialog
		  title="提示"
		  :visible.sync="dialogVisible"
		  width="30%"
		  :before-close="handleClose">
		  <span class="text-left" v-html="body"></span>
		  <span slot="footer" class="dialog-footer pointer" @click="dialogVisible = false">
		    确 定
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				addarea: [],
				addressinfo: [], //展示城市类别
				ishowcity: false, //
				provinceList: [], // 省列表
				cityList: [], //市
				
				fileList:[],//文件列表
				labelPosition: 'left',//
				formLabelAlign: {
					title: '',//标题
					desc: '',//描述
					money: '',//预算金额
					settlement: '',//信息类别
					category: '',//全部类别
					area:'',//地址
				},
				radio: "1",
				profession:[],//
				file:'',//上传的文件
				array: [
					{
						name: '招标公告',
						id:1
					},
					{
						name: '中标结果',
						id:2
					}
				],//结算方式
				value: '',
				rules: {
					title: [{
						required: true,
						message: '请用一段话，描述您的岗位标题',
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: '请描述岗位详情',
						trigger: 'blur'
					}],
					category: [{
						required: true,
						message: '请选择工种类别',
						trigger: 'change'
					}],
					years: [{
							required: true,
							message: '请填写经验年限',
							trigger: 'blur'
						},
						{
							type: 'number',
							message: '经验年限必须为数字值'
						}
					],
					settlement: [{
						required: true,
						message: '请选择活动区域',
						trigger: 'change'
					}]
				},//表单校验
				dialogVisible: false,
				body:'',//蓝友网信息发布规则
			};
		},
		created() {
			this.getcate()
			this.getcity()
			this.getagreement()
		},
		methods: {
			getagreement(){
				this.ajax('get', '/api/pc/agreement/getInfo', {
					type:10,
				}, res => {
					// res = res.data
					if(res.status == 200){
						this.body = res.data.content
					}else{
						this.$message.info(res.msg);
					}
				})
			},
			getcate() {
				this.ajax('get', '/api/pc/bidding/getBiddingCate', {}, res => {
					console.log(res);
					if (res.status == 200) {
						this.profession = res.data
					} else {
						this.$message(res.msg);
					}
				})
			},
			//获取城市列表
			getcity() {
				this.ajax('get', '/api/work/getCityList', {}, res => {
					if (res.status == 200) {
						let list = res.data;
						list.forEach(item => {
							let obj = {
								id: 0,
								level: 1,
								pid: item.id,
								name: '不限',
							}
							if (item.children){
								if(item.children.length > 1){
									item.children = [obj, ...item.children]
								}
							}else{
								item.children = [obj]
							}
							
							item.children.map(plp => {
								plp.ischeck = false
							})
						})
						this.provinceList = list;
						this.cityList = list[0].children
					}
				})
			},
			//导入文件
			handleChange(file, fileList) {
				console.log(file,fileList);
				this.file = file.response.data.url
			},
			//保存提交
			submitForm() {
				console.log(this.$refs.formLabelAlign);
				this.$refs.formLabelAlign.validate((valid) => {
					if (valid) {
						this.sub()
						// alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//导入文件
			uploadFile() {
				this.$refs.fileRef.dispatchEvent(new MouseEvent('click'))
			},
			//展示城市选择器
			chosecit() {
				this.ishowcity = !this.ishowcity
			},
			//选择省
			chooseProvince(item,index) {
				this.provinceIndex = index;
				this.cityList = item.children
				// this.cityIndex = null;
			},
			//选择市
			chooseCity(item,index) {
				let cityId;
				let citylength = this.addarea.length
				if (!item.ischeck) {
					if(citylength < 3){
						let ala = this.provinceList[this.provinceIndex]
						if(item.id == 0){//不限
							this.addarea.push(ala)
							
							ala.children.map(clc=>{
								clc.ischeck = false
								this.addarea.map((ele,elex)=>{
									if(ele.id == clc.id){
										this.addarea.splice(elex,1)
									}
								})
							})
							item.ischeck = !item.ischeck
						}else{
							this.addarea.map((ele,elex)=>{
								if(ele.id == ala.id){
									this.addarea.splice(elex,1)
								}
							})
							this.cityIndex = index;
							item.ischeck = !item.ischeck
							this.addarea.push(item)
						}
						
					}else{
						this.$message('最多可选3个城市')
					}
				}else{
					item.ischeck = !item.ischeck
					let ala = this.provinceList[this.provinceIndex]
					if(item.id == 0){
						this.addarea.map((ele,elex)=>{
							if(ele.id == ala.id){
								this.addarea.splice(elex,1)
							}
						})
					}else{
						this.addarea.map((ele,elex)=>{
							if(ele.id == item.id){
								this.addarea.splice(elex,1)
							}
						})
					}
					
				}
				this.addressinfo = []
				this.addarea.map(ele => {
					this.addressinfo.push(ele.name)
				})
			},
			sub(){
				let model = this.$refs.formLabelAlign.model
				
				let info = {
					title:model.title,
					content:model.desc,
					bidding_cate_id:model.category,
					budget:model.money,
					result:model.settlement,
					area:this.addressinfo.join(','),
					id:''
				}
				this.ajax('post', '/api/pc/bidding/addBidding',info, res => {
					
					if (res.status == 200) {
						this.$message.success('发布成功');
					} else {
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.dialog-footer{
		width: 383px;
		height: 46px;
		background: #09827B;
		padding: 10px 32px;
		border-radius: 16px;
		color: #fff;
	}
	.cascadera {
		// width: 740px;
		min-height: 54px;
		position: relative;
	
		.casca {
			padding: 0 10px;
			width: 100%;
			height: 54px;
			line-height: 54px;
			border: 1px solid #E6E6E6;
			border-radius: 8px;
		}
	
		ul,
		li {
			list-style: none;
		}
	
		.cate {
			overflow: hidden;
			position: absolute;
			top: 54px;
			z-index: 9;
	
			.blobk300 {
				height: 200px;
				min-width: 180px;
				box-sizing: border-box;
				overflow: auto;
				line-height: 35px;
				border: 1px solid #E6E6E6;
			}
	
			// .blobk300:hover{
			// 	overflow: auto;
			// }
		}
	
	
		::-webkit-scrollbar {
			width: 5px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 1px;
		}
	
		::-webkit-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
			background: #666;
			transition: background 1s;
		}
	
		::-webkit-scrollbar-track {
			/*滚动条里面轨道*/
			box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
			border-radius: 10px;
			background: #ededed;
		}
	}
	
	
	
	.all {
		width: 921px;
		height: 878px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2000);
		border-radius: 20px;
		padding-top: 40px;
	}

	.titmep {
		width: 740px;
		border: 1px solid #E6E6E6;
		border-radius: 8px;
		outline: 0;
	}

	.bge {
		background: rgba(230, 230, 230, 0.3000);
	}

	.txtmep {
		width: 740px;
		height: 126px;
		border: 1px solid #E6E6E6;
		border-radius: 8px;
		outline: 0;
	}

	.height54 {
		height: 54px;
	}

	.el-form-item {
		margin-bottom: 19px;
	}

	.el-cascader,
	.el-select {
		width: 740px;
		height: 54px;
	}

	/deep/ .el-input>input {
		text-align: right;
		height: 54px;
	}

	.creat {
		width: 383px;
		height: 46px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9, 130, 123, 0.2000);
		border-radius: 23px;
		margin-top: 60px;
		margin-bottom: 20px;
	}

	.fillbtn {
		display: flex;
		justify-content: flex-start;
		margin-left: 100px;
		margin-bottom: 20px;
	}

	.tnb {
		color: #09827B;
		border: 1px solid #09827B;
		background: rgba(230, 230, 230, 0.3000);
		border-radius: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/tender/bidding.vue